import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
    Handler,
} from "@insite/client-framework/HandlerCreator";
import {
    RequestBrandDetailsProductFamilies,
    RequestBrandDetailsProductFamiliesModel,
} from "@tCentro/Services/CENBrandDetailsProductFamilesService";
import CustomApplicationState from "@tCentro/Store/CustomApplicationState";
import { getBrandProductFamilies } from "@tCentro/Store/Reducer/BrandProductFamiliesSelectors";

export interface RequestBrandDetailsProductFamiliesParameter {
    brandId: string;
}

type HandlerType = ApiHandler<RequestBrandDetailsProductFamiliesParameter, { apiResult: RequestBrandDetailsProductFamiliesModel }>;

export const SkipIfAlreadyLoaded: Handler<RequestBrandDetailsProductFamiliesParameter> = props => {
    const entry = getBrandProductFamilies(props.getState() as CustomApplicationState, props.parameter.brandId);
    
    if (entry && (entry.isLoading || entry.families)) {
        return false; // stop the chain
    }
};

export const DispatchBeginLoad: Handler<RequestBrandDetailsProductFamiliesParameter> = props => {
    props.dispatch({ type: "Data/BrandProductFamilies/BeginLoad", brandId: props.parameter.brandId });
};

export const RequestData: HandlerType = async (props: any) => {
    try {
        props.apiResult = await RequestBrandDetailsProductFamilies({ brandid: props.parameter.brandId });
    } catch {
        props.dispatch({ type: "Data/BrandProductFamilies/Failed", brandId: props.parameter.brandId });
        return false;
    }
};

export const DispatchLoaded: HandlerType = (props: any) => {
    props.dispatch({
        type: "Data/BrandProductFamilies/Loaded",
        brandId: props.parameter.brandId,
        families: props.apiResult.productFamilies ?? [],
    });
};

export const chain = [SkipIfAlreadyLoaded, DispatchBeginLoad, RequestData, DispatchLoaded];

const CENRequestBrandDetailsProductFamiliesData = createHandlerChainRunner(
    chain,
    "CENRequestBrandDetailsProductFamiliesData",
);

export default CENRequestBrandDetailsProductFamiliesData;